export default __webpack_public_path__ + "static/section-stats-1-28dce937faa5299097375460f981a125.jpg";